import React from 'react';
import '../../screens/Legalreports/PrintComponent/styles.scss';
import PrintFunctions from '../../screens/Legalreports/Print/PrintFunctions';

const PrintableShiftReport = React.forwardRef(({ rows }, ref) => {
  const { getEmployeeInfo, getCompanyInfo } = PrintFunctions();

  const renderData = () => {
    const headers = () => [
      'Fecha Asignación Turno',
      'Turno Asignado',
      'Extensión del Turno',
      'Asignación de Nuevo Turno',
      'Inicio del turno',
      'Nuevo Turno',
      'Extensión del Nuevo Turno',
      'Solicitante',
      'Observaciones'
    ];

    return (
      <div
        className="table_to_print print_report"
        ref={ref}
        style={{
          margin: '0 auto',
          maxWidth: '800px',
          padding: '20px'
        }}
      >
        {rows &&
          rows.map((log, index) => (
            <div className="employee-report-block" key={log.employee_id || index}>
              <p style={{ fontWeight: 'bold' }}>Reporte de modificación de turnos</p>
              {getCompanyInfo(log)}
              {getEmployeeInfo(log)}
              <p>
                <br />
              </p>

              <table className="table-print table-sm table-bordered">
                <thead style={{ backgroundColor: '#EBEBEB' }}>
                  <tr>
                    {headers().map(header => (
                      <th className="text-center align-middle" key={header}>
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                {!log.shift_log || log.shift_log.length === 0 ? (
                  <tbody>
                    <tr>
                      <td colSpan="9" style={{ textAlign: 'center' }}>
                        {!log.shift_log
                          ? 'NO HAY TRABAJADORES QUE COINCIDAN CON LA SELECCIÓN.'
                          : 'Sin cambios o modificaciones de turnos en el periodo consultado'}
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  log.shift_log.map((shiftLog, sIdx) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <tbody key={`shiftLog-${shiftLog.original_shift_date}-${shiftLog.new_shift_date}-${sIdx}`}>
                      <tr>
                        <td className="text-center align-middle">{shiftLog.original_shift_date}</td>
                        <td style={{ textAlign: 'left' }}>{shiftLog.original_turn_name}</td>
                        <td className="text-center align-middle">{shiftLog.original_shift_extension}</td>
                        <td className="text-center align-middle">{shiftLog.new_shift_date}</td>
                        <td className="text-center align-middle">{shiftLog.new_shift_start_date}</td>
                        <td style={{ textAlign: 'left' }}>{shiftLog.new_turn_name}</td>
                        <td className="text-center align-middle">{shiftLog.new_shift_extension}</td>
                        <td className="text-center align-middle">{shiftLog.solicitor}</td>
                        <td className="text-center align-middle">{shiftLog.observatio}</td>
                      </tr>
                    </tbody>
                  ))
                )}
              </table>
            </div>
          ))}
      </div>
    );
  };

  return <>{renderData()}</>;
});

export default PrintableShiftReport;
